<template>
  <main>
    <Header :data="headerData" />
    <PlanBody
      :leadID="leadID"
      :pPerson="pPerson"
      :pJob="pJob"
      :pPrice="pPrice"
      :pSons="pSons"
      :pPartner="pPartner"
      :pNewsletter="pNewsletter"
      :responseData3="responseData2"
      
    />
    <Footer />
  </main>
</template>

<script>
import Header from "./../components/header/Header";
import Footer from "./../components/footer/Footer";
import PlanBody from "./../components/plan/PlanBody";
// const csvFilePath = "./data/ubicacionPorCategoria.csv";
export default {

  props: {
    responseData: {
      type: Object,
      default: () => {},
    },
  },

  

    mounted() {
    //console.log("Response data in Plan component:", this.responseData);
  },

  components: { Header, Footer, PlanBody },
  name: "Plan",
  metaInfo: {
    title: "Plan",
  },
  created() {
    window.scroll(document.body.scrollHeight, 0);
  },
  data() {
    return { 
      responseData2: this.responseData,


      leadID: this.$store.getters.getPersonForm.leadID,
      pPerson: this.$store.getters.getPersonForm.person,
      pJob: this.$store.getters.getPersonForm.personJobIn,
      pPrice: this.$store.getters.getPersonForm.personInputPrices,
      pSons: this.$store.getters.getPersonForm.personSonsData,
      pNewsletter: this.$store.getters.getPersonForm.personNewsletterData,
      pPartner: this.$store.getters.getPersonForm.personPartnerData,
      precioBasico: 100,

      headerData: {
        logo: "plan-gracias",
        menu: [
          { type: "to", to: "/", text: "Iniciar cotizador" },
          {
            type: "href",
            href: "https://www.osfatun.com.ar/",
            text: "Ir al sitio web",
          },
        ],
      },
    };
  },
};
</script>
